import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconFilters = createIcon({
  displayName: 'IconFilters',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M6 11H8V5H6V7H1V9H6V11ZM10 7H23V9H10V7ZM1 15H14V17H1V15ZM16 13H18V15H23V17H18V19H16V13Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
